import { useId, type ReactNode } from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Figma account card („Card · Osobné údaje“ 205:11129, „Card · Nové heslo“ 207:11374): 1 px
 * #E2E5DF border, radius 16, padding 24 (16 on phones), 16 px rows; the title in Heading/H5 with
 * an optional element on its right (the „Fyzická osoba“ chip).
 */
export function AccountCard({
  title,
  aside,
  className,
  children,
}: {
  title?: ReactNode;
  aside?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  const titleId = useId();

  return (
    <section
      aria-labelledby={title ? titleId : undefined}
      className={cn(
        'flex min-w-0 flex-col gap-4 rounded-2xl border border-[#E2E5DF] bg-white p-4 sm:p-6',
        className,
      )}
    >
      {title ? (
        <header className="flex flex-wrap items-center gap-3">
          <h2 id={titleId} className="nt-h5 min-w-0 flex-1 text-[#0D110D]">
            {title}
          </h2>
          {aside}
        </header>
      ) : null}
      {children}
    </section>
  );
}

/**
 * Figma „Heading“ of the account pages: the H2 title over a Body/L #363D36 text, 8 px apart, 8 px
 * padding below (24 px to the first card with the content's 16 px gap).
 */
export function AccountHeading({ title, text }: { title: ReactNode; text?: ReactNode }) {
  return (
    <header className="flex flex-col gap-2 pb-2">
      <h1 className="nt-h2 text-[#0D110D]">{title}</h1>
      {text ? <p className="nt-body-l text-[#363D36]">{text}</p> : null}
    </header>
  );
}
